var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDefault(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-defaultimage"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "defaultimage",
    clipPath: "url(#clip-defaultimage)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "iconfinder_Line_ui_icons_Svg-09_1465834",
    transform: "translate(0 1.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    "data-name": "Group 24",
    transform: "translate(2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    "data-name": "Group 23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M24.328,11.45V12.6a1.687,1.687,0,0,1,1.718,1.718V24.618a1.718,1.718,0,0,1-3.435,0V2.863A2.835,2.835,0,0,0,19.748,0H4.863A2.835,2.835,0,0,0,2,2.863V24.618a2.835,2.835,0,0,0,2.863,2.863H24.328a2.835,2.835,0,0,0,2.863-2.863V14.313A2.835,2.835,0,0,0,24.328,11.45ZM3.145,24.618V2.863A1.687,1.687,0,0,1,4.863,1.145H19.748a1.687,1.687,0,0,1,1.718,1.718V24.618a2.944,2.944,0,0,0,.573,1.718H4.863A1.687,1.687,0,0,1,3.145,24.618Z",
    transform: "translate(-2)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 1,
    height: 7,
    transform: "translate(6 16.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 1,
    height: 12,
    transform: "translate(9 11.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    width: 1,
    height: 7,
    transform: "translate(12 16.74)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    width: 1,
    height: 12,
    transform: "translate(15 11.74)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M26.58,12.58V8H22Z",
    transform: "translate(-10.55 -3.42)",
    fill: "#b2b2b2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDefault);
export default __webpack_public_path__ + "static/media/iconDefault.e70b9527.svg";
export { ForwardRef as ReactComponent };